export const UiKitComponent = ({ render, blocks }) => render(blocks);
